<template>
  <svg :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg">
    <use :xlink:href="href" fill="currentColor" fill-rule="evenodd" />
  </svg>
</template>
<script>
const KNOWN_ICONS = [
  "ic-alert",
  "ic-angle-down",
  "ic-angle-left",
  "ic-angle-right",
  "ic-angle-up",
  "ic-calendar",
  "ic-certificate-indicator",
  "ic-check",
  "ic-cross",
  "ic-dots",
  "ic-download",
  "ic-duplicate",
  "ic-info",
  "ic-lock",
  "ic-menu",
  "ic-plus",
  "ic-polygon",
  "ic-search",
  "ic-success",
  "ic-table",
  "ic-user",
  "logo"
];
export default {
  name: "MtgIcon",
  props: {
    icon: {
      type: String,
      required: true,
      validator: function(value) {
        return KNOWN_ICONS.includes(value);
      }
    },
    viewBox: {
      type: String,
      default: "0 0 24 24"
    }
  },
  computed: {
    href() {
      return "images/svg/sprite.svg#" + this.icon;
    }
  }
};
</script>
